/*
 * Previously called opcaddress_enhanced.js
 * Removed the "_enhanced" from the file name to keep things consistent.
 * 
 * BOOT-6833 - Eliminate old feature flags & unused JS files
 */ 

'use strict';

var _ = require('lodash');
var ajax = require('../../ajax');
var dialog = require('../../dialog');
var findMoreStores = require('../../findMoreStores');
var tooltip = require('../../tooltip');
var util = require('../../util');
var TPromise = require('promise');
var AddressAutocompleteDialog;
var AddressVerificationDialog;
var AddressVerificationHelper = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/AddressVerification/AddressVerificationHelper');
var CheckoutConstants = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/CheckoutConstants');
var GoogleTagManagerClient = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/util/GoogleTagManagerClient');
var SiteConstants = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');
var ValidationHelper = require('../../../../../bc_sheplersbootbarn_core/cartridge/scripts/util/ValidationHelper');
var ValidationRules = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/ValidationConstants').Rules;
var ValidationSettings = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/ValidationConstants').Settings;

var shippingMethods;
var isStoreShippingAddressOnly;
var options = {};
var dataBuffer = {};
// Matches cart.js's loadingIndicatorSettings exactly - the same fullscreen loader shown for
// Save/setOPCAddress, reused here for "Use My Location" so both dialogs stay consistent.
var loadingIndicatorSettings = {
	IsLabelShown: false,
	CssClass: 'fullscreen',
	BackgroundColor: 'transparent'
};

var billingAddressFormContainerSelector = '.billing-address-form';
var $billingAddressFormContainer = $(billingAddressFormContainerSelector);
var billingAddressFormSelector = '#billingAddressForm';
var $billingAddressForm = $(billingAddressFormSelector);
var shippingAddressSectionSelector = '.form-checkout.shipping-address-section';
var $shippingAddressSection = $(shippingAddressSectionSelector);
var shippingAddressFormContainerSelector = '.shipping-address-form';
var $shippingAddressFormContainer = $(shippingAddressFormContainerSelector);
var shippingAddressFormSelector = '#shippingAddressForm';
var $shippingAddressForm = $(shippingAddressFormSelector);
var paymentFormContainerSelector = '.payment-section';
var $paymentFormContainer = $(paymentFormContainerSelector);
var paymentFormSelector = '#paymentSection';
var $paymentForm = $(paymentFormSelector);
var $sectionCheckout = $('.section-checkout');
var $shippingMethodList = $('.form-checkout.payment-section #shipping-method-list');

var shippingAddressFormValidator;
var billingAddressFormValidator;

function initializeEvents() {
	$(document).ready(function() {
        if (!SitePreferences.PROMOTIONAL_SMS) {
            $('#billingAddressForm').find('[field="promotionalsms"]').hide();
        } else {
			if ($('.promotionalSMSLabel').length) {
				var promoSMSLabelText = $('.promotionalSMSLabel').html();
				$('#billingAddressForm [field="promotionalsms"] label span').html(promoSMSLabelText);
			}
		}
    });

	$sectionCheckout.on('click', '.find-more-stores a', function () {
		findMoreStores.initialize({ view: 'checkout', storeQuery: StoreQueryFilters.ShipToStoreEnabled });
	});
	
	$(document).on('click', '.international-checkout', function() {
		location.reload();
	});
	
	$(document).on('change', 'form [id*="_country"]', function () {
		var $this = $(this);
		var $form = $this.closest('form');
		var $stateDropdown = $form.find('[id*="states_state"]');

		renderOptions('#' + $stateDropdown.attr('id'), '#' + $this.attr('id'));

		var $initialState = $form.find('.initial-state');
		var initialStateValue = $initialState.val();
		var $selectedStateOption = $stateDropdown.find('option[value="' + initialStateValue + '"]');
		if ($selectedStateOption.length > 0) {
			$stateDropdown.val(initialStateValue);
			$selectedStateOption.prop('selected', true);
		}

		if ($form.attr('id') == $shippingAddressForm.attr('id') && $this.val()) {
			if ($this.val().toUpperCase() == SiteConstants.CountryCodes.UnitedStates) {
				$('#shipping-international-info').hide();
			} else {
				$('#shipping-international-info').show();
			}
		}
	});

	$(document).on('change', 'form [id*="_postal"]', function () {
		var $this = $(this);
		$this.val($this.val().toUpperCase());
	});

	$('.shipping-same').on('click', function(){
		if($('.shipping-same').is(':checked')){
			$('input[name$="_useAsShippingAddress"]').prop('checked', true);
		} else {
			$('input[name$="_useAsShippingAddress"]').prop('checked', false);
		}
	});

	$('.add-diff').on('click', function(){
		$('input[name$="_useAsShippingAddress"]').prop('checked', false);
	});

	$billingAddressFormContainer.on('click', '.edit-address-det', function (e) {
		e.preventDefault();
		editBillingAddress();
	});

	$billingAddressFormContainer.on('click', '.cancel-address-det', function (e) {
		e.preventDefault();

		$('.bill-address-fields').addClass('collapsed').hide();
		$('.billing-select-address').show();

		$('.billing-address-preview').show();
		$('.billing-address-data.form-info').show();

		$billingAddressForm.hide();
		$shippingAddressFormContainer.show();

		$shippingAddressSection.addClass('active').find('.shipping-address-cont').removeClass('hidden');

		if ($shippingAddressSection.attr('panel-mode') != 'view') {
			$shippingAddressForm.show();
		} else {
			$shippingAddressForm.hide();
			$('.form-checkout.payment-section').addClass('active').find('.shipping-payment-cont').removeClass('hidden');
		}
		
		if ($('.shipping-methods-section .shipping-restrictions').length == 0) {
			$('.payment-methods-section').show();
		}
	});

	$('.shipping-address-section').on('click', '.edit-address-det', function (e) {
		e.preventDefault();
		editShippingAddress();
	});

	$('.shipping-address-section').on('click', '.add-address-det', function (e) {
		e.preventDefault();

		writeShippingAddressFormToBuffer();

		$('.form-checkout.shipping-address-section').attr('panel-mode', 'add');
		$shippingAddressFormContainer.data('hidden-editable', true).hide();
		$('.shipping-address-data').hide();
		$shippingAddressFormContainer.show();

		$shippingAddressForm.removeClass('add edit').addClass('add');
		$shippingAddressForm.find('input[name="action"]').val('add');

		$billingAddressForm.hide();
		$('.billing-address-data.form-info').css('display', 'block');
		$('.form-checkout.payment-section').removeClass('active').find('.shipping-payment-cont').addClass('hidden');

		var $shippingAddressFormFields = $shippingAddressForm.find('.editaddress-shipping');
		$('.editaddress-shipping .initial-state').val('');

		$('.shipping-select-address').hide();
		$('.editaddress-shipping').removeClass('collapsed');
		$('#dwfrm_singleshipping_addressList').val('');

		$shippingAddressFormFields.find('input:text, input:password, input:file, textarea').val('');
		$shippingAddressFormFields.find('option[default]').prop('selected', true);
		$shippingAddressFormFields.find('input:checkbox, input:radio').not('[name*="shippingAddress_addToAddressBook"]').removeAttr('checked');

		$('#dwfrm_shippingaddress_country').trigger('change');
	});

	$('.shipping-address-section').on('click', '.cancel-address-det', function (e) {
		e.preventDefault();

		writeBufferToShippingAddressForm();
   		submitShipping(true);
	});

    $('.single.shipping-address-type-selector input').on('click', function () {
		var shippingAddressType = $(this).val();
        shippingAddressFormValidator.form();
		$('.form-checkout.shipping-address-section').attr('panel-mode', 'blank');
		$('.shipping-address-cont span.error').remove();
		$('.shipping-address-cont input, .shipping-address-cont select').removeClass('error');
		
        if (shippingAddressType == SiteConstants.AddressTypes.Customer) {
        	$shippingAddressForm.find('.formfield input[type="text"], .formfield select').not('[disabled]').not('#dwfrm_shippingaddress_myStoreID').val('');
        	$('.form-checkout.shipping-address-section').attr('shipping-address-type', 'my-address').attr('value', 'false');
        	
        	if ($('#dwfrm_multipleshipping_addressList option').length > 0 || dataBuffer.shippingAddressFields && dataBuffer.shippingAddressFields['dwfrm_shippingaddress_firstName']) {
				writeBufferToShippingAddressForm();
        		
				if ($shippingAddressForm.valid()) {
					$('.shipping-address-data.form-info').html('').append(buildDetailsBlockForForm($shippingAddressForm));
					$('.shipping-address-data').show();
				
					$shippingAddressForm.hide();
					$('.payment-section').addClass('active');
					$('.shipping-payment-cont').removeClass('hidden');
					$('.shipping-address-cont').removeClass('hidden'); 
					$shippingAddressForm.data('shipping-filled', true);
				}
				
				if ($('#dwfrm_multipleshipping_addressList option').length > 0) {
					$('#dwfrm_multipleshipping_addressList').trigger('change');
				}
			} else {
				$shippingAddressForm.find('.formfield option[default]').prop('selected', true);
				$shippingAddressForm.data('shipping-filled', false);
				$('.form-checkout.address-section').attr('panel-mode', 'view');

				$shippingAddressFormContainer.data('hidden-editable', true).hide();
				$('.shipping-address-data.form-info').hide();
				$shippingAddressFormContainer.show();
				$shippingAddressForm.removeClass('add edit').addClass('edit');
				$shippingAddressForm.find('input[name="action"]').val('edit');

				$('.editaddress-shipping').removeClass('collapsed');
				setShipToStore(false);
			}

			setShipToStore(isShipToStoreEnabled());
			$('.shipping-address-cont').removeClass('hidden');

			if (shippingAddressFormValidator.checkForm()) {
				setOPCAddress(shippingAddressFormSelector, 'dwfrm_shippingaddress_saveopcaddress').then(function (data) {
    				handleShippingRestrictions(data);	
					$('.payment-section').addClass('active');
					$('.shipping-payment-cont').removeClass('hidden');

					updateShippingMethodList($shippingAddressForm, true, null);
				});
			} else {
				updateShippingMethodList($shippingAddressForm, true, null);
				$('.payment-section').removeClass('active');
				$('.shipping-payment-cont').addClass('hidden');
			}

			$('.billing-address-data.form-info').css('display', 'block');

            if ($('.multiple.select-address option').length > 0) {
            	$('.multiple.select-address').show();
            } else {
            	$('.multiple.select-address').hide();
            }

        	$('.single.select-address').hide();
        } else if (shippingAddressType == SiteConstants.AddressTypes.Store) {
			$shippingAddressForm.hide();
            $('.editaddress-shipping').addClass('collapsed');
            $('.multiple.select-address').hide();
            $('.single.select-address').show();
			$('#mystores_addressList').trigger('change');
        }
    });

    $('select[name$="_addressList"]', $billingAddressForm).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');

        if (!selectedAddress) { return; }

        util.fillAddressFields(selectedAddress, $billingAddressForm);
        billingAddressFormValidator.form();
    });

    $('select[name$="_addressList"]', $shippingAddressForm).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');

        if (!selectedAddress) { return; }

        util.fillAddressFields(selectedAddress, $shippingAddressForm);
        shippingAddressFormValidator.form();
    });

    $('#submitBilling').on('click', function(e){
    	e.preventDefault();
    	submitBilling();
    });

    $('#submitShipping').on('click', function(e) {
    	e.preventDefault();
    	submitShipping();
    });

	$('.toggle.top, .toggle.bottom').on('click', function(e){
    	e.preventDefault();
    	$('#internationalinfo').slideToggle();
	});

	if (options && options.Lob && options.Lob.AddressAutocomplete.Enabled) {
		$(document).off('keyup.AddressAutocomplete').on('keyup.AddressAutocomplete', billingAddressFormSelector + ' input[type="text"], ' + shippingAddressFormSelector + ' input[type="text"]', function (event) {
			var $this = $(this);
			var $form = $this.closest('form');
			var formValidator = $form.validate();

			if (event.keyCode == 8 || event.keyCode == 46) {
				$this.parent().find('.address-autocomplete-dialog').remove();
			} else if (!formValidator.checkForm() && $this.attr('id').indexOf('_address1') >= 0) {
				var addressAutocompleteHandler = function (addressAutocompleteData) {
					AddressAutocompleteDialog.initialize(options, addressAutocompleteData);
				}
			
				AddressVerificationHelper.AutocompleteAddress($form, $this, options).then(addressAutocompleteHandler);
			} else {
				$this.parent().find('.address-autocomplete-dialog').remove();
			}
		});
		
		$(document).off('SetAddressFromAddressAutocomplete').on('SetAddressFromAddressAutocomplete', function (event, data) {
			AddressVerificationHelper.SetAddressFromAddressVerificationDialog(data.$form, data.Address);
		});
	}

	if (options && options.Lob && options.Lob.AddressVerification.Enabled) {
		$(document).off('SetAddressFromAddressVerification').on('SetAddressFromAddressVerification', function (event, addressData) {
			if (addressData.AddressType == 'billing') {
				AddressVerificationHelper.SetAddressFromAddressVerificationDialog($billingAddressForm, addressData);
				submitBilling(true, addressData.SkipUseBillingAsShipping);
			} else if (addressData.AddressType == 'shipping') {
				AddressVerificationHelper.SetAddressFromAddressVerificationDialog($shippingAddressForm, addressData);
				submitShipping(false, true);
			}
		});
	}

	$(document).on('opc.SetShippingAddress', function (e, address) {
		var templateSettings = {
				interpolate: /{{([\s\S]+?)}}/g
	    	};

		var template = _.template($('#template-address-selector-option').html(), templateSettings);

		address.ID = address.key;
		if (address.isMyStore && !address.myStoreID && address.storeId) {
			address.myStoreID = address.storeId;
		}

		var templateData = _.extend(address, {
			id: address.UUID,
			cssClass: 'find-more-store-option',
			selected: 'selected',
			text: address.labelText
		});

		var $addressList = $('#mystores_addressList');

		var addressIndexInList = null;
		$addressList.find('option').each(function (index, object) {
			if (address.ID == $(object).val()) {
				addressIndexInList = index;
				return false;
			}
		});

	    if (addressIndexInList) {
			$addressList.prop('selectedIndex', addressIndexInList);
		} else {
			dataBuffer['mystores_addressList'] = dataBuffer['mystores_addressList'].filter(function (address) {
				return !address.isTemporary;
			});

			address.isTemporary = true;
			dataBuffer['mystores_addressList'].push(address);
			dataBuffer['store_name_lookup'][address.firstName] = address.fullName;
			
			$addressList.find('.find-more-store-option').remove();
			$addressList.prepend(template(templateData)).prop('selectedIndex', 0);
		}

	    $('#mystores_addressList').trigger('change');
	});

	$(document).on('change', '#dwfrm_multipleshipping_addressList, #mystores_addressList', function (e) {
		var $this = $(this);
		var actionName = 'dwfrm_shippingaddress_saveopcaddress';
		$('.shipping-address-cont span.error').remove();
		$('.shipping-address-cont input, .shipping-address-cont select').removeClass('error');

		var $target = $(e.currentTarget);
        var selectedAddress;
		if ($target && $target.attr('id')) {
			var dataBufferForAddressList = dataBuffer[$target.attr('id')];
			if (dataBufferForAddressList) {
				selectedAddress = dataBufferForAddressList.filter(function (address) {
					return address.UUID == $target.val();
				})[0];
			}
		}

        if (!selectedAddress) {
        	return false;
        }

		var isStoreAddress = false;
		var storeId;
        if (selectedAddress.hasOwnProperty('isMyStore') && selectedAddress.myStoreID) {
			isStoreAddress = selectedAddress.isMyStore;
			storeId = selectedAddress.myStoreID;
        }

		setShipToStore(isStoreAddress);

		if (isStoreAddress) {
			$shippingAddressForm.find('.formfield.myStoreID input').val(storeId);
		} else {
			$shippingAddressForm.find('.formfield input[type="text"], .formfield select').not('[disabled]').not('#dwfrm_shippingaddress_myStoreID').val('');
			util.fillAddressFields(selectedAddress, $shippingAddressForm);
		}
		$this.find('option.placeholder').remove();

		setOPCAddress(shippingAddressFormSelector, actionName).then(function (data) {
			handleShippingRestrictions(data);
			$shippingAddressForm.data('shipping-filled', true);
			$shippingAddressForm.hide();
			$('.shipping-address-data.form-info').html('').append(buildDetailsBlockForAddress(selectedAddress, false, false, 'shippingAddressForm'));
			$('.shipping-address-data').show();

			if (billingAddressFormValidator.valid()) {
				$('.shipping-payment-cont').removeClass('hidden');
				$('.payment-section').addClass('active');
			} else {
				$('.shipping-payment-cont').addClass('hidden');
				$('.payment-section').removeClass('active');
				$('.billing-address-data.form-info').hide();

				$billingAddressFormContainer.show();
				$billingAddressFormContainer.find('input.required.field.error').eq(0).focus();
			}
			
			updateShippingMethodList($shippingAddressForm, true, isStoreAddress);
		}.bind(this));
	});

	$('#dwfrm_billing_addressList').on('change', function() {
    	$('.custom-email-error').remove();
    	var isEmailValid = util.validateEmail($('#dwfrm_billingaddress_email').val());

		if ($(this).val() && billingAddressFormValidator.valid() && isEmailValid) {
			$billingAddressForm.hide();
			$('.billing-address-data').html('').append(buildDetailsBlockForForm($billingAddressForm)).show();
			$('.shipping-address-cont').removeClass('hidden');
			$('.shipping-address-section').addClass('active');
			$('.form-checkout.address-section').attr('panel-mode', 'view').attr('value', 'true');
		} else {
			editBillingAddress();
			$('.shipping-address-cont').addClass('hidden');
			$('.shipping-address-section').removeClass('active');
		}
	});

	function renderZipSearchResults($storeSelector, stores) {
		var $results = $storeSelector.find('.zip-search-results');
		$results.empty();

		stores.forEach(function (store) {
			var $option = $('<label class="store-option"></label>');
			var $radio = $('<input type="radio" name="ZipSearchStoreId" />').val(store.StoreId);
			var $radioCircle = $('<span class="radio-circle"></span>');
			var $details = $('<span class="store-details-text"></span>');

			$details.append($('<span class="store-name"></span>').text(store.Name));
			$details.append($('<span class="store-address"></span>').text(
				store.Address1 + ', ' + store.City + ', ' + store.StateCode + ' ' + store.PostalCode
			));

			$option.append($details).append($radio).append($radioCircle);
			$results.append($option);
		});

		$results.off('click.ShipToStore.PickResult').on('click.ShipToStore.PickResult', '.store-option', function () {
			$results.find('.store-option').removeClass('selected');
			var $checkedRadio = $(this).addClass('selected').find('input[name="ZipSearchStoreId"]').prop('checked', true);
			$storeSelector.data('pendingStoreId', $checkedRadio.val());
		});

		// The results list just grew the dialog's content height - re-center it vertically now
		// that it's taller, same trick repSelectionsModal.js uses (reassert the current position
		// option to force jQuery UI to recompute it).
		if ($storeSelector.dialog('instance')) {
			$storeSelector.dialog('option', 'position', $storeSelector.dialog('option', 'position'));
		}
	}

	function openShipToStoreDialog($shippingMethod) {
		// Cached on $shippingMethod (never relocated) rather than re-found via .find() every time -
		// once .store-selector has been dialog-ified once, it no longer lives inside
		// [shipping-method] until destroyed, so a plain .find() here would come up empty on any
		// open after the first.
		var $storeSelector = $shippingMethod.data('storeSelectorDialog') || $shippingMethod.find('.store-selector');
		$shippingMethod.data('storeSelectorDialog', $storeSelector);

		// Destroy any stale instance from a previous open here, rather than inside that instance's
		// own close callback (kept that way for safety, though the actual "second open does
		// nothing" bug turned out to be in dialog.js's close() calling methods on a stale singleton
		// reference - see dialog.js).
		if ($storeSelector.dialog('instance')) {
			$storeSelector.dialog('destroy');
			$storeSelector.hide();
		}

		// Snapshot the currently-committed store so Cancel can revert to it.
		$storeSelector.data('originalSelectValue', $storeSelector.find('select').val());

		// Deliberately not calling the shared dialog.close() here - this function already destroys
		// its own prior instance of THIS element above; the shared singleton's close() would instead
		// dismiss whatever unrelated dialog (cookie consent, quickview, etc.) happens to be open
		// elsewhere on the page at the moment this one opens.
		dialog.create({
			target: $storeSelector,
			options: {
				title: 'Change Ship-to-Store',
				dialogClass: 'ship-to-store-dialog',
				// BOOT-5386's responsive-dialog pattern (dialog.js) defaults width to '100%' and caps
				// it via CSS max-width - a literal width here overrode that default outright, forcing
				// this dialog to a fixed 480px even on screens narrower than that and clipping content
				// on mobile. maxWidth keeps the same 480px cap on desktop while staying responsive.
				maxWidth: 480,
				open: function () {
					$('.ui-widget-overlay').addClass('rep-selections-overlay');
				},
				close: function () {
					$('.ui-widget-overlay').removeClass('rep-selections-overlay');
					// destroy() deliberately NOT called here - see the guard at the top of this
					// function instead, which runs it safely on the NEXT open (a fresh call stack,
					// not nested inside this close event).
				}
			}
		});
		$storeSelector.dialog('open');
	}

	$(document).off('click.ShipToStore.Change').on('click.ShipToStore.Change', '[shipping-method] .store-details .change', function (e) {
		openShipToStoreDialog($(this).closest('[shipping-method]'));
	});

	// Scoped to .store-selector itself, NOT [shipping-method] - once the dialog opens, jQuery UI
	// relocates .store-selector out from under [shipping-method] (appends it near <body>), which
	// breaks any selector requiring that outer ancestor. .store-selector still travels with its
	// own descendants regardless of where it currently sits, so scoping to it directly is safe.
	$(document).off('change.ShipToStore.SelectStore').on('change.ShipToStore.SelectStore', '.store-selector select', function (e) {
		var $storeSelector = $(this).closest('.store-selector');
		$storeSelector.find('.zip-search-results .store-option').removeClass('selected');
		$storeSelector.find('.zip-search-results input[name="ZipSearchStoreId"]').prop('checked', false);
		$storeSelector.data('pendingStoreId', $(this).val());
	});

	// Mirrors repSelectionsModal.js's showZipError/clearZipError exactly - error text comes from the
	// error span's own data-error-message (set in the template), not a hardcoded JS string, and the
	// error state clears live as the rep types, not just on the next submit attempt.
	function showZipError($zip, $error) {
		$zip.addClass('error');
		$error.text($error.data('errorMessage')).addClass('visible');
	}

	function clearZipError($zip, $error) {
		$zip.removeClass('error');
		$error.removeClass('visible');
	}

	$(document).off('input.ShipToStore.ZipSearch').on('input.ShipToStore.ZipSearch', '.store-selector .zip-search-input', function (e) {
		var $zipSearchForm = $(this).closest('.zip-search-form');
		clearZipError($(this), $zipSearchForm.find('.error'));
	});

	// .zip-search-form is a <div>, not a <form> - this content sits inside checkout's own outer
	// form, and a nested <form> start tag is silently dropped by the browser's HTML parser (nested
	// forms are invalid HTML), leaving a submit button with nothing to submit. So this triggers on
	// the Search button's click and the zip field's Enter key directly, rather than a form submit.
	function runZipSearch($zipSearchForm) {
		var $storeSelector = $zipSearchForm.closest('.store-selector');
		var $zip = $zipSearchForm.find('.zip-search-input');
		var $error = $zipSearchForm.find('.error');
		var $searchButtonContainer = $zipSearchForm.find('.btn-store-search-container');

		clearZipError($zip, $error);

		if ($.trim($zip.val()).length !== 5) {
			showZipError($zip, $error);
			return;
		}

		$searchButtonContainer.loading();

		$.ajax({
			url: Urls.searchStoresByZip,
			type: 'GET',
			dataType: 'json',
			data: { Zip: $.trim($zip.val()) }
		}).done(function (result) {
			if (result && result.Success && result.Stores && result.Stores.length > 0) {
				clearZipError($zip, $error);
				renderZipSearchResults($storeSelector, result.Stores);
			} else {
				$storeSelector.find('.zip-search-results').empty();
				showZipError($zip, $error);
			}
		}).fail(function () {
			$storeSelector.find('.zip-search-results').empty();
			showZipError($zip, $error);
		}).always(function () {
			if ($searchButtonContainer.attr('loading')) {
				$searchButtonContainer.loading('destroy');
			}
		});
	}

	$(document).off('click.ShipToStore.ZipSearch').on('click.ShipToStore.ZipSearch', '.store-selector .zip-search-form .store-search', function (e) {
		e.preventDefault();
		runZipSearch($(this).closest('.zip-search-form'));
	});

	$(document).off('keydown.ShipToStore.ZipSearch').on('keydown.ShipToStore.ZipSearch', '.store-selector .zip-search-input', function (e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
			e.preventDefault();
			runZipSearch($(this).closest('.zip-search-form'));
		}
	});

	$(document).off('click.ShipToStore.Geolocation').on('click.ShipToStore.Geolocation', '.store-selector .geolocation', function (e) {
		var $geolocationLink = $(this);
		var $storeSelector = $geolocationLink.closest('.store-selector');
		var $zip = $storeSelector.find('.zip-search-input');
		var $error = $storeSelector.find('.zip-search-form .error');

		if (!navigator.geolocation) {
			return;
		}

		// Same fullscreen loader Save/setOPCAddress() uses, for consistency - no bespoke
		// modal-scoped spinner treatment.
		$('body').loading(loadingIndicatorSettings);

		navigator.geolocation.getCurrentPosition(function (position) {
			$.ajax({
				url: Urls.searchStoresByZip,
				type: 'GET',
				dataType: 'json',
				data: { Latitude: position.coords.latitude, Longitude: position.coords.longitude }
			}).done(function (result) {
				if (result && result.Success && result.Stores && result.Stores.length > 0) {
					clearZipError($zip, $error);
					renderZipSearchResults($storeSelector, result.Stores);
				} else {
					$storeSelector.find('.zip-search-results').empty();
					showZipError($zip, $error);
				}
			}).fail(function () {
				$storeSelector.find('.zip-search-results').empty();
				showZipError($zip, $error);
			}).always(function () {
				if ($('body').attr('loading')) {
					$('body').loading('destroy');
				}
			});
		}, function () {
			showZipError($zip, $error);
			if ($('body').attr('loading')) {
				$('body').loading('destroy');
			}
		});
	});

	$(document).off('click.ShipToStore.Apply').on('click.ShipToStore.Apply', '.store-selector .apply', function (e) {
		var $storeSelector = $(this).closest('.store-selector');
		var storeId = $storeSelector.data('pendingStoreId') || $storeSelector.find('select').val();

		$storeSelector.dialog('close');
		if ($storeSelector.dialog('instance')) {
			$storeSelector.dialog('destroy');
		}
		$storeSelector.hide();

		if (!storeId) {
			return;
		}

		$shippingAddressForm.find('.formfield.myStoreID input').val(storeId);

		setOPCAddress(shippingAddressFormSelector, 'dwfrm_shippingaddress_saveopcaddress').then(function (data) {
			updateShippingMethodList($shippingAddressForm, true);
		});
	});

	$(document).off('click.ShipToStore.Cancel').on('click.ShipToStore.Cancel', '.store-selector .cancel', function (e) {
		var $storeSelector = $(this).closest('.store-selector');

		// Revert anything touched during this open - the select and any zip-search pick - so
		// nothing from a canceled interaction lingers into a later Apply.
		var originalValue = $storeSelector.data('originalSelectValue');
		if (originalValue !== undefined) {
			$storeSelector.find('select').val(originalValue);
		}
		$storeSelector.removeData('pendingStoreId');
		$storeSelector.find('.zip-search-results').empty();
		$storeSelector.find('.zip-search-input').val('');
		clearZipError($storeSelector.find('.zip-search-input'), $storeSelector.find('.zip-search-form .error'));

		$storeSelector.dialog('close');
		if ($storeSelector.dialog('instance')) {
			$storeSelector.dialog('destroy');
		}
		$storeSelector.hide();
	});

	$(document).off('click.ShippingMethod.Select').on('click.ShippingMethod.Select', 'input[name*="_shippingMethodID"]', function (event) {
		var $this = $(this);
		var $shippingMethod = $this.closest('[shipping-method]');
		var $shipment = $this.closest('form');

		if ($shippingMethod.attr('status') == 'disabled') {
			event.preventDefault();
		} else {
			selectShippingMethod($shipment.attr('shipment'), $this.val(), $shippingMethod.attr('is-ship-to-store') == 'true', $shippingMethod); 
		}
	});

	$(document).off('focus.AutofillHandler').on('focus.AutofillHandler', 'div.billing-address-form input[type="text"], div.shipping-address-form input[type="text"]', function (event) {
		var $this = $(this);
		var $form = $this.closest('form');
		var autofillCount = $form.find('input:-webkit-autofill').length;

		if (window.innerWidth <= 768) {
			if (autofillCount == 0) {
				$form.attr('auto-filled', false);
			}

			if ($form.attr('auto-filled') != 'true') {
				dataBuffer.AutofillDetectorInterval = setInterval(function() {
					autofillCount = $form.find('input:-webkit-autofill').length;
					if (autofillCount > 0 && $form.attr('auto-filled') != 'true') {
						$form.attr('auto-filled', true);
						$this.attr('inputmode', 'none');
						$this.trigger('blur');
						setTimeout(function() {
							$this.removeAttr('inputmode');
						}, 250);
					}
				}, 250);
			}
		}
	});
}

$(document).off('blur.AutofillHandler').on('blur.AutofillHandler', 'div.billing-address-form input[type="text"], div.shipping-address-form input[type="text"]', function (event) {
	if (dataBuffer && dataBuffer.AutofillDetectorInterval) {
		clearInterval(dataBuffer.AutofillDetectorInterval);
	}
});

function initializeUserInterface() {
	$('#dwfrm_shippingaddress_ID').val('');
	$('.form-checkout.address-section').attr('panel-mode', 'blank');
	$('.form-checkout.shipping-address-section').attr('panel-mode', 'blank').attr('value', 'false');

	var billingAddress = getAddressFromForm($billingAddressForm);
	var shippingAddress = getAddressFromForm($shippingAddressForm);
	var $billingSavedAddrDropdown = $('#dwfrm_billing_addressList');
	var didBillingAddressSuccessHandlerRun = false;
	var didShippingAddressSuccessHandlerRun = false;
	
	$('#dwfrm_billingaddress_country').trigger('change');
	$('#dwfrm_shippingaddress_country').trigger('change');

	$.validator.addMethod('requiredExcludingPunctuation', ValidationHelper.ValidateRequiredExcludingPunctuation, Resources.INVALID_VALUE);
	$.validator.addMethod('postalCode', ValidationHelper.ValidatePostalCode, Resources.INVALID_POSTAL_CODE);
	$.validator.addMethod('postOfficeBoxOnly', ValidationHelper.ValidateAddressForPostOfficeBoxOnly, Resources.INVALID_POST_OFFICE_BOX_ONLY);
	
	billingAddressFormValidator = $billingAddressForm.validate();
	billingAddressFormValidator.settings.ignore = [":not(.required)"];
	billingAddressFormValidator.settings.onfocusout = ValidationSettings.Checkout.onfocusout;
	billingAddressFormValidator.settings.errorPlacement = ValidationSettings.Checkout.errorPlacement;
	$billingAddressForm.find('input[name$="_firstName"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$billingAddressForm.find('input[name$="_lastName"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$billingAddressForm.find('input[name$="_address1"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$billingAddressForm.find('input[name$="_address1"]').rules('add', ValidationRules.ValidateAddressForPostOfficeBoxOnly);
	$billingAddressForm.find('input[name$="_address2"]').rules('add', ValidationRules.ValidateAddressForPostOfficeBoxOnly);
	$billingAddressForm.find('input[name$="_city"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$billingAddressForm.find('input[name$="_postal"]').rules('add', ValidationRules.RequiredExcludingPunctuation);

	shippingAddressFormValidator = $shippingAddressForm.validate();
	shippingAddressFormValidator.settings.ignore = [":not(.required)"];
	shippingAddressFormValidator.settings.onfocusout = ValidationSettings.Checkout.onfocusout;
	shippingAddressFormValidator.settings.errorPlacement = ValidationSettings.Checkout.errorPlacement;
	$shippingAddressForm.find('input[name$="_firstName"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$shippingAddressForm.find('input[name$="_lastName"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$shippingAddressForm.find('input[name$="_address1"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$shippingAddressForm.find('input[name$="_address1"]').rules('add', ValidationRules.ValidateAddressForPostOfficeBoxOnly);
	$shippingAddressForm.find('input[name$="_address2"]').rules('add', ValidationRules.ValidateAddressForPostOfficeBoxOnly);
	$shippingAddressForm.find('input[name$="_city"]').rules('add', ValidationRules.RequiredExcludingPunctuation);
	$shippingAddressForm.find('input[name$="_postal"]').rules('add', ValidationRules.RequiredExcludingPunctuation);

	if (!billingAddress.address1 && $billingSavedAddrDropdown.find('option').length && $billingSavedAddrDropdown.val()) {
		$billingSavedAddrDropdown.trigger('change');
	} else {
		if (billingAddressFormValidator.checkForm()) {
			$billingAddressForm.find('input.shipping-same').prop('checked', false);
			$billingAddressForm.find('input.shipping-newsletter-signup').prop('checked', false);
			didBillingAddressSuccessHandlerRun = billingAddressSuccessHandler(null, true);
		} else {
			editBillingAddress();
		}
	}

	renderMyStoresAddressSelector();
	var $shippingSavedAddrDropdown = $('#dwfrm_multipleshipping_addressList');
	if (billingAddressFormValidator.checkForm() && !didBillingAddressSuccessHandlerRun) {
		if (!shippingAddress.address1 && $shippingSavedAddrDropdown.find('option').length && $shippingSavedAddrDropdown.val()) {
			$shippingSavedAddrDropdown.trigger('change');
		} else {
			if (shippingAddressFormValidator.checkForm()) {
				didShippingAddressSuccessHandlerRun = shippingAddressSuccessHandler(true);
				verifyShipping();
			} else {
				editShippingAddress();
			}
		}
	}
	
	$('.form-checkout.shipping-address-section .select-address.multiple').show();
	$('.address-section').addClass('active');
	
	if (didBillingAddressSuccessHandlerRun && shippingAddressFormValidator.checkForm() && window.innerWidth <= 767) {
		setTimeout(function() {
			$([document.documentElement, document.body]).scrollTop($('.form-checkout.payment-section').offset().top - $('.header-wrapper').height() + 20);
		}, 1000);
	}
}

function billingAddressSuccessHandler(responseData, skipUpdateShippingMethodList, isVerified, skipUseBillingAsShipping) {
	var $shippingSavedAddrDropdown = $('#dwfrm_multipleshipping_addressList');
	var shippingAddress = getAddressFromForm($shippingAddressForm);

	$billingAddressForm.hide();
	$('.form-checkout.address-section').attr('panel-mode', 'view').attr('value', 'true');
	$('.billing-address-data').html('').append(buildDetailsBlockForForm($billingAddressForm)).show();
	$('.shipping-address-cont').removeClass('hidden');

	if (responseData && responseData.status == 'success' && !skipUseBillingAsShipping && ($('#isShippingAddressSameAsBillingAddress').prop('checked') || $('[has-store-pickup-shipment-only]').attr('has-store-pickup-shipment-only') == 'true')) {
		populateBillingAddressFormToShippingAddressForm();
	}
	
	if (responseData && responseData.status == 'shippingAddressValidationError') {
		editShippingAddress();
	} else if (!skipUseBillingAsShipping && ($('#isShippingAddressSameAsBillingAddress').prop('checked') || $('[has-store-pickup-shipment-only]').attr('has-store-pickup-shipment-only') == 'true')) {
		$('.shipping-address-data.form-info').html('').append(buildDetailsBlockForForm($shippingAddressForm));
		$('.shipping-address-data').show();

		$shippingAddressForm.hide();
		$shippingAddressForm.data('shipping-filled', true);
		$paymentFormContainer.addClass('active');
		$('.shipping-payment-cont').removeClass('hidden');
		submitShipping(null, isVerified);
	} else if (shippingAddressFormValidator.checkForm()) {
		shippingAddressSuccessHandler(skipUpdateShippingMethodList);
	} else if (!shippingAddress.address1 && $shippingSavedAddrDropdown.find('option').length && $shippingSavedAddrDropdown.val()) {
		$shippingSavedAddrDropdown.trigger('change');
	} else {
		editShippingAddress();
	}

	$('.shipping-address-section').addClass('active').show();

	if (!skipUpdateShippingMethodList) {
		updateShippingMethodList($shippingAddressForm, true);
	}

	if ($shippingAddressForm.data('shipping-filled') == true) {
		$paymentFormContainer.addClass('active').find('.shipping-payment-cont').removeClass('hidden');
		$shippingAddressForm.hide();
		$('.shipping-address-data').show();
	}

	if (window.innerWidth <= 767) {
		$(window).scrollTop($('.shipping-address-section').offset().top - $('.header-wrapper').height());
	}
	
	return true;
}

function shippingAddressSuccessHandler(skipUpdateShippingMethodList, isCancel, isVerified) {
	var selectedAddressID;
	var currentAddressIDs = [];
	var $shippingSelect = $('#dwfrm_multipleshipping_addressList');
	var $blankOption = $('<option>', { 'class': 'placeholder', 'value': '', 'text': Resources.OPC_SELECT_ADDR });

	$('.select-address.address-selector select option').map(function() { currentAddressIDs.push($(this).val()); });

	if ($shippingAddressForm.hasClass('add') || ($shippingAddressForm.hasClass('edit') && !$shippingAddressForm.find('.set-default-shipping input').prop('checked'))) {
		selectedAddressID = "new";
		$shippingAddressForm.find('input[name$="_ID"]').val('');

		if ($shippingSelect.find('option.placeholder').length == 0) {
			$shippingSelect.prepend($blankOption).prop('selectedIndex', 0);
		}
	} else {
		selectedAddressID = $('.select-address.address-selector select').val();
	}

	writeShippingAddressFormToBuffer();
	var panelMode = $shippingAddressSection.attr('panel-mode');
	$shippingAddressForm.removeClass('add edit');
	$('.form-checkout.shipping-address-section').attr('panel-mode', 'view');
	
	var renderAddressSelectorCallback = function (data) {
		$shippingAddressForm.data('shipping-filled', true);
		$shippingAddressForm.hide();
		$shippingAddressForm.find('input[name="action"]').val('');

		if (!isCancel && (panelMode == 'add' || panelMode == 'edit')) {
			if ($shippingSelect.find('option.placeholder').length == 0) {
				$shippingSelect.prepend($blankOption).prop('selectedIndex', 0);
			}
			if (data && data.selectedAddressID) {
				$shippingSelect.val(data.selectedAddressID).val(data.selectedAddressID).prop('selectedIndex', $shippingSelect.find('option:selected').index());
			} else if (data && !data.selectedAddressID) {
				$shippingSelect.prop('selectedIndex', 0);
			}
		}

		$('.shipping-address-data.form-info').html('').append(buildDetailsBlockForForm($shippingAddressForm));
		$('.shipping-address-data').show();
		if (!isVerified) {
			verifyShipping(isCancel, isVerified);
		}

		if (billingAddressFormValidator.checkForm()) {
			$('.shipping-payment-cont').removeClass('hidden');
    		$('.payment-section').addClass('active');
		} else {
			$('.shipping-payment-cont').addClass('hidden');
			$('.payment-section').removeClass('active');
			$('.billing-address-data.form-info').hide();

			var formBody = $('.billing-address-form');
			formBody.show();
			formBody.find('input.required.field.error').eq(0).focus();
		}

		if (!skipUpdateShippingMethodList) {
			updateShippingMethodList($shippingAddressForm, true, null, true);
		}
	}

	var isAuthenticated = $sectionCheckout.attr('is-authenticated') == "true";
	if (isAuthenticated) {
		renderAddressSelector({
			container: '.select-address.address-selector',
			el: '.select-address.address-selector .field-wrapper',
			id: 'dwfrm_multipleshipping_addressList',
			selected: selectedAddressID,
			currentAddresses: currentAddressIDs,
			callback: renderAddressSelectorCallback
		});
	} else {
		renderAddressSelectorCallback();
	}

	if (window.innerWidth <= 767) {
		$(window).scrollTop($('.payment-section').offset().top - $('.header-wrapper').height());
	}
	
	return true;
}

function submitBilling(isVerified, skipUseBillingAsShipping) {
	$('#submitBilling').attr('disabled', true);
	if ($('.billing-address-type-selector input[value=1]').prop('checked') && $('#dwfrm_billing_addressList').val() == '') {
		$('#submitBilling').attr('disabled', false);
		return;
	}

	if ($('#isShippingAddressSameAsBillingAddress').is(':checked') || $('[has-store-pickup-shipment-only]').attr('has-store-pickup-shipment-only') == 'true') {
		$('input[name$="_useAsShippingAddress"]').prop('checked', true);
	} else {
		$('input[name$="_useAsShippingAddress"]').prop('checked', false);
	}

	billingAddressFormValidator.form();
	$('.custom-email-error').remove();

	var isEmailValid = util.validateEmail($('#dwfrm_billingaddress_email').val());
	if (billingAddressFormValidator.valid() && isEmailValid) {
		$billingAddressForm = $(billingAddressFormSelector);
		$billingAddressFormContainer.find('.validation-error-container').removeAttr('role').hide();
		verifyBilling(null, isVerified, skipUseBillingAsShipping);
	} else {
		$billingAddressFormContainer.find('.validation-error-container').attr('role','alert').show();
		$('#submitBilling').attr('disabled', false);
		if (!isEmailValid && billingAddressFormValidator.valid()) {
			$('#dwfrm_billingaddress_email').addClass('error').parent().append('<span class="error custom-email-error">' + Resources.VALIDATE_EMAIL + '</span>');
		}
		$('.billing-address-type-selector input[value="2"]').trigger('click', [true]);
	}
}

function verifyBilling(isCancel, isVerified, skipUseBillingAsShipping) {
	var addressDeliverable = function () {
		setOPCAddress(billingAddressFormSelector, $('#selectOpcAddress').attr('name'), skipUseBillingAsShipping).then(function (data) {
			billingAddressSuccessHandler(data, null, true, skipUseBillingAsShipping);
			$('#submitBilling').attr('disabled', false);
		});
	}

	var addressNotDeliverable = function (addressVerifyData) {
		AddressVerificationDialog.initialize(options, 'billing', addressVerifyData);
		$('#submitBilling').attr('disabled', false);
	}

	// Transactional SMS
	var populateSMSphone = function () {
		if (SitePreferences.TRANSACTIONAL_SMS) {
			var billingPhone = $billingAddressForm.find('[id*="_phone"]').val();
			$('.order-transactional-sms-phone input[id*="transactionalsms_smsPhone"]').val(billingPhone).trigger('input');
		}
	}

	var country = $billingAddressForm.find('[id*="_country"]').val();
	if (!isVerified && options && options.Lob && options.Lob.AddressVerification.Enabled && country.toUpperCase() == 'US') {
		AddressVerificationHelper.VerifyAddress($billingAddressForm, options).then(addressDeliverable, addressNotDeliverable);
	} else {
		addressDeliverable();
	}
	populateSMSphone();
}

function submitShipping(isCancel, isVerified) {
	$('#submitShipping').attr('disabled', true);
	$('.shipping-address-cont span.error').remove();
	$('.shipping-address-cont input, .shipping-address-cont select').removeClass('error');

	shippingAddressFormValidator.form();
	if ($shippingAddressForm.valid()) {
		$shippingAddressFormContainer.find('.validation-error-container').removeAttr('role').hide();
		verifyShipping(isCancel, isVerified);
	} else {
		$shippingAddressFormContainer.find('.validation-error-container').attr('role','alert').show();
		$('#submitShipping').attr('disabled', false);
	}
}

function verifyShipping(isCancel, isVerified) {
	var addressDeliverable = function () {
		setOPCAddress(shippingAddressFormSelector, $('#submitShipping').attr('name')).then(function (data) {
			var isShippingRestricted = handleShippingRestrictions(data);
			$('#submitShipping').attr('disabled', false);
			if (!isShippingRestricted) {
				shippingAddressSuccessHandler(false, isCancel, true);
				$('.payment-methods-section').show();
			}
		});
	}

	var addressNotDeliverable = function (addressVerifyData) {
		AddressVerificationDialog.initialize(options, 'shipping', addressVerifyData);
		$('#submitShipping').attr('disabled', false);
	}

	var country = $shippingAddressForm.find('[id*="_country"]').val();
	if (!isVerified && options && options.Lob && options.Lob.AddressVerification.Enabled && country.toUpperCase() == 'US') {
		AddressVerificationHelper.VerifyAddress($shippingAddressForm, options).then(addressDeliverable, addressNotDeliverable);
	} else {
		addressDeliverable();
	}
}

function writeBufferToAddressForm(name, $selector) {
	if (dataBuffer[name]) {
		$selector.each(function (index, element) {
			var $field = $(element);
			$field.val(dataBuffer[name][$field.attr('name')] || '');
		});
		
		if (name == 'shippingAddressFields') {
			var $form = $('.shipping-address-form');
			var $countryDropdown = $form.find('[id*="_country"]');
			var $stateDropdown = $form.find('[id*="states_state"]');
			renderOptions('#' + $stateDropdown.attr('id'), '#' + $countryDropdown.attr('id'));
			
			if ($('#dwfrm_shippingaddress_states_state').length > 0 && dataBuffer['shippingAddressFields']['dwfrm_shippingaddress_states_state']) {
				$('#dwfrm_shippingaddress_states_state').val(dataBuffer['shippingAddressFields']['dwfrm_shippingaddress_states_state']);
			}
		}
	}
}

function writeBufferToShippingAddressForm() {
	var $shippingAddressFields = $shippingAddressForm.find('.formfield input[type="text"], .formfield select').not('[disabled]').not('#dwfrm_shippingaddress_myStoreID');
	writeBufferToAddressForm('shippingAddressFields', $shippingAddressFields);
}

function writeAddressFormToBuffer(name, $selector, doClear) {
	$selector.each(function (index, element) {
		var $field = $(element);

		if ($field.val()) {
			if (!dataBuffer[name]) {
				dataBuffer[name] = {};
			}

			dataBuffer[name][$field.attr('name')] = $field.val();
		}
	});

	if (doClear) {
		$selector.val('');
		$selector.find('option[default]').prop('selected', true);
	}
}

function writeShippingAddressFormToBuffer(doClear) {
	var $shippingAddressFields = $shippingAddressForm.find('.formfield input[type="text"], .formfield select').not('[disabled]').not('#dwfrm_shippingaddress_myStoreID');
	writeAddressFormToBuffer('shippingAddressFields', $shippingAddressFields, doClear);
}

/**
 * create address object from form
 * @param $form
 * @returns Address Object
 */
function getAddressFromForm($form) {
	return {
		ID: util.htmlEncode($form.find('input[name$="_ID"]').val()),
		isStore: util.htmlEncode($form.find('input[name$="_isStore"]').prop('checked')),
		firstName: util.htmlEncode($form.find('input[name$="_firstName"]').val()),
		lastName: util.htmlEncode($form.find('input[name$="_lastName"]').val()),
		address1: util.htmlEncode($form.find('input[name$="_address1"]').val()),
		address2: util.htmlEncode($form.find('input[name$="_address2"]').val()),
		address3: util.htmlEncode($form.find('input[name$="_address3"]').val()),
		countryCode: util.htmlEncode($form.find('select[id$="_country"]').val()),
		stateCode: util.htmlEncode($form.find('select[id$="_state"]').val()),
		postalCode: $form.find('input[name$="_postal"]').val() ? util.htmlEncode($form.find('input[name$="_postal"]').val().toUpperCase()) : '',
		city: util.htmlEncode($form.find('input[name$="_city"]').val()),
		phone: util.htmlEncode($form.find('input[name$="_phone"]').val()),
		email: util.htmlEncode($form.find('input[name$="_email"]').val())
	};
}

function populateBillingAddressFormToShippingAddressForm() {
	var billingAddress = getAddressFromForm($billingAddressForm);

	$shippingAddressForm.find('input[name$="_ID"]').val('');
	$shippingAddressForm.find('input[name$="_firstName"]').val(billingAddress.firstName).trigger('change');
	$shippingAddressForm.find('input[name$="_lastName"]').val(billingAddress.lastName).trigger('change');
	$shippingAddressForm.find('input[name$="_address1"]').val(billingAddress.address1).trigger('change');
	$shippingAddressForm.find('input[name$="_address2"]').val(billingAddress.address2).trigger('change');
	$shippingAddressForm.find('input[name$="_address3"]').val(billingAddress.address3).trigger('change');
	$shippingAddressForm.find('input[name$="_postal"]').val(billingAddress.postalCode).trigger('change');
	$shippingAddressForm.find('input[name$="_city"]').val(billingAddress.city).trigger('change');
	$shippingAddressForm.find('select[id$=country]').val(billingAddress.countryCode).trigger('change');
	$shippingAddressForm.find('select[id$=state]').val(billingAddress.stateCode).trigger('change');
	$shippingAddressForm.find('input[name$="_phone"]').val(billingAddress.phone).trigger('change');

    if ($('#dwfrm_multipleshipping_addressList').find('option.placeholder').length == 0) {
    	$('#dwfrm_multipleshipping_addressList').prepend('<option class="placeholder">' + Resources.OPC_SELECT_ADDR + '</option>').prop('selectedIndex', 0);
    }
}

function buildDetailsBlockForForm($form, isCompact, hideNickname) {
	var address = getAddressFromForm($form);
	for (var addressKey in address) {
    	if (address[addressKey] != null && address[addressKey].search(/\^/) != -1) {
    		address[addressKey] = address[addressKey].replace(/\^/gi,"'");
    	}
    }

	return buildDetailsBlockForAddress(address, isCompact, hideNickname, $form.attr('id'));
}

function buildDetailsBlockForAddress(address, isCompact, hideNickname, formId) {
	var shippingAddressType = getShippingAddressType();
    var htmlText = $('<div/>', {"class": "address-details-st"});
    var header = isCompact ? '' : formId == 'billingAddressForm' ? '<h6>Billing Recipient</h6>' : formId == 'shippingAddressForm' ? '<h6>Ship To:</h6>' : '';
    var editButton = (!isCompact && !shippingAddressType || shippingAddressType == SiteConstants.AddressTypes.Customer) ? '<p class="text-right edit-address-container"><a class="edit-address-det" tabindex="0">Edit<span class="visually-hidden">&nbsp;Address Information</span></a></p>' : '';
    var addNewButton = '';
	var addressNickname = '';
	
	if (formId == 'shippingAddressForm') {
		if (address.address1 && !hideNickname) {
			if (address.ID && !address.myStoreID) {
				addressNickname = address.ID;
			} else if (formId == 'shippingAddressForm' && shippingAddressType == SiteConstants.AddressTypes.Customer && dataBuffer['dwfrm_multipleshipping_addressList']) {
				var selectedAddressFromDropdown = dataBuffer['dwfrm_multipleshipping_addressList'].filter(function (addressOption) {
					return addressOption.UUID == $('#dwfrm_multipleshipping_addressList').val();
				});
				
				if (selectedAddressFromDropdown.length > 0 && selectedAddressFromDropdown[0].displayValue && $('[has-warehouse-shipment]').attr('has-warehouse-shipment') == 'true') {
					util.fillAddressFields(selectedAddressFromDropdown[0], $('#shippingAddressForm'));
					writeShippingAddressFormToBuffer();
					addressNickname = selectedAddressFromDropdown[0].displayValue;
				}
			}
			
			if (addressNickname) {
				addressNickname = '<span class="address-nickname">' + addressNickname + '</span>';
			}

			$('.form-checkout.shipping-address-section').attr('panel-mode', 'view').attr('value', 'true');
		}
		
		if (!isCompact && shippingAddressType == SiteConstants.AddressTypes.Customer) {
			addNewButton = '<p class="add-address-container"><a class="add-address-det" tabindex="0">+ Add New Address</a></p>';
		}
	}
	
    var htmlcontent = '';
    if (address.address1) {
	    htmlcontent += header;
	    htmlcontent += '<div class="address" tabindex="0"><div>' + (address.myStoreID ? address.fullName : address.firstName) + ' ' + address.lastName + addressNickname + ' </div>';
	    htmlcontent += '<div>' + address.address1 + ' </div>';
	    if (address.address2) {
	    	htmlcontent += '<div>' + address.address2 + ' </div>';
	    }

	    if (address.address3) {
	    	htmlcontent += '<div>' + address.address3 + ' </div>';
	    }

	    htmlcontent += '<div>' + address.city;

	    if (address.stateCode && address.stateCode.toUpperCase() != 'OTHER') {
	    	htmlcontent += ' ' + address.stateCode;
	    }

	    htmlcontent += ' ' + address.postalCode;
		htmlcontent += ' ' + address.countryCode + '</div>';
		if (address.phone) {
			htmlcontent += '<div>' + address.phone + '</div>';
		}

	    if (address.email) {
	    	htmlcontent += '<div class="billing-email-address">' + address.email + '</div>';
		}
		htmlcontent += '</div>';

		if (formId != 'shippingAddressForm' || (!options || !options.Workforce || !options.Workforce.HasForceShippingAddress)) {
			htmlcontent += editButton;
		}
		if (formId == 'shippingAddressForm' && (!options || !options.Workforce || !options.Workforce.HasForceShippingAddress)) {
			htmlcontent += addNewButton;
		}
    }

    htmlText.html(htmlcontent);

    return htmlText;
}

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL($form, url, extraParams) {
    var params = {
		isStore: $form.find('input[name$="_isStore"]').prop('checked'),
		myStoreID: $form.find('input[name$="_myStoreID"]').val(),
    	address1: $form.find('input[name$="_address1"]').val(),
        address2: $form.find('input[name$="_address2"]').val(),
        address3: $form.find('input[name$="_address3"]').val(),
        countryCode: $form.find('select[id$="_country"]').val(),
        stateCode: $form.find('select[id$="_state"]').val(),
        postalCode: $form.find('input[name$="_postal"]').val(),
        city: $form.find('input[name$="_city"]').val()
    };

    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

function updateShippingMethodList($form, doUpdateSummary, isMyStore, doDataLayerPush, $selectedShippingMethod) {
	if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
	
	var shippingMethodListData = {
		selectedPaymentMethod: $paymentForm.find('input[name*="_selectedPaymentMethodID"]').val()
	}

	var $shipToStoreOptionInAddressPanel = $('.single.shipping-address-type-selector');
	if ($shipToStoreOptionInAddressPanel.length > 0) {
		if ($shipToStoreOptionInAddressPanel.find('input:checked').val() == SiteConstants.AddressTypes.Store) {
			shippingMethodListData.ShipToStoreOnly = true;

			if (dataBuffer[CheckoutConstants.User.SelectedStoreShippingMethod]) {
				shippingMethodListData.SelectShippingMethod = dataBuffer[CheckoutConstants.User.SelectedStoreShippingMethod];
			}
		} else if ($shipToStoreOptionInAddressPanel.find('input:checked').val() == SiteConstants.AddressTypes.Customer) {
			shippingMethodListData.ShipToStoreExclude = true;

			if (dataBuffer[CheckoutConstants.User.SelectedCustomerShippingMethod]) {
				shippingMethodListData.SelectShippingMethod = dataBuffer[CheckoutConstants.User.SelectedCustomerShippingMethod];
			}
		}
	}

	if (isMyStore) {
		shippingMethodListData.ShipToStoreOnly = true;
	}

	var shippingMethodListUrl = getShippingMethodURL($form, Urls.shippingMethodsList);
	$shippingMethodList.load(shippingMethodListUrl, shippingMethodListData, function () {
		var selectedStore = $shippingAddressForm.find('.formfield.myStoreID input').val();
		var $shipToStoreShippingMethods;
		if (options && options.AgentStore && options.AgentStore.StoreShippingAddressOnly) {
			$shipToStoreShippingMethods = $('[shipping-method]');
		} else {
			$shipToStoreShippingMethods = $('[shipping-method][is-ship-to-store="true"]');
		}

		if ($shipToStoreShippingMethods.length > 0) {
			var selectedStoreFromShippingMethod = $shipToStoreShippingMethods.find('.store-selector select').val();

			if (selectedStoreFromShippingMethod && selectedStoreFromShippingMethod != selectedStore && $shipToStoreShippingMethods.find('.input-radio').is(':checked')) {
				selectedStore = selectedStoreFromShippingMethod;
				$shippingAddressForm.find('.formfield.myStoreID input').val(selectedStore);
				setOPCAddress(shippingAddressFormSelector, 'dwfrm_shippingaddress_saveopcaddress').then(function (data) { });
			}

			buildShipToStoreDetails($shipToStoreShippingMethods);
		}

		if (selectedStore && dataBuffer && dataBuffer['mystores_addressList']) {
			var selectedStoreInBuffer = dataBuffer['mystores_addressList'].filter(function (address) {
				return address.myStoreID == selectedStore;
			})[0];

			if (selectedStoreInBuffer && selectedStoreInBuffer.UUID != $('#mystores_addressList').val()) {
				$('#mystores_addressList').val(selectedStoreInBuffer.UUID);
				var shippingAddressType = getShippingAddressType();
				if (shippingAddressType == SiteConstants.AddressTypes.Store) {
					$('#mystores_addressList').trigger('change');
					doUpdateSummary = false;
				}
			}
		}
		$shippingMethodList.fadeIn('fast');

		if (doUpdateSummary) {
			updateSummary();
		}
		
		tooltip.init({
			items: '.shipping-method-tooltip',
			tooltipClass: 'shipping-method-tooltip'
		}, $('[shipping-method]'));
		tooltip.init({
			items: '.tooltip.RewardsCredit',
			tooltipClass: 'RewardsCredit'
		}, $('[payment-method="REWARDS_CREDIT"]'));
		tooltip.init({
			items: '.tooltip.LoyaltyCredit',
			tooltipClass: 'LoyaltyCredit'
		}, $('[payment-method="LOYALTY_CREDIT"]'));
		tooltip.init({
			items: '.tooltip'
		}, $('.form-row.cvn'));

		var isStoreAddress = isShipToStoreEnabled();
		setShipToStore(isStoreAddress);

		if (doDataLayerPush) {
			pushDataLayerForShippingMethods($shippingMethodList, $selectedShippingMethod);
		}
	});
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    $(document).trigger('Cart.Update', {
		'EventTriggers': {
			'update-shipping': false
		}
	});
}

function getShippingAddressType() {
	var shippingAddressType = $('.single.shipping-address-type-selector input:checked').val();
	if (!shippingAddressType) {
		shippingAddressType = SiteConstants.AddressTypes.Customer;
	}
	return shippingAddressType;
}

function renderMyStoresAddressSelector(parameters) {
	var templateSettings = {
    	interpolate: /{{([\s\S]+?)}}/g
    };

    var templates = [];
	templates['option'] = _.template($('#template-address-selector-option').html(), templateSettings);

	$.ajax({
		method: 'POST',
		url: Urls.getMyStoresAddressList,
		contentType: 'application/json',
		data: JSON.stringify({ storeQuery: StoreQueryFilters.ShipToStoreEnabled }),
		dataType: 'json',
		success: function(data) {
			var html = [];
			html['options'] = '';

			dataBuffer['mystores_addressList'] = data.addresses;
			dataBuffer['store_name_lookup'] = {};
			data.addresses.map(function (element) {
				dataBuffer['store_name_lookup'][element.myStoreID] = element.fullName;
			});

			var isStoreAddressSelected = false;
			for (var index = 0; index < data.addresses.length; index++) {
				var address = data.addresses[index];

				if (address.isSelected) {
					isStoreAddressSelected = true;
				}
				
				var optionData = _.extend(address, {
					id: address.UUID,
					cssClass: '',
					selected: address.isSelected ? 'selected' : '',
					text: address.labelText
				});

				optionData.ID = address.myStoreID;
				html['options'] += templates['option'](optionData);
			}

			$('#mystores_addressList').html(html['options']);

			if (isStoreAddressSelected) {
				setShipToStore(true);
				$('.single.shipping-address-type-selector input[value="' + SiteConstants.AddressTypes.Store + '"]').click();
			}
			
			if (parameters && parameters.callback) {
				parameters.callback();
			}
		}
	});
}

function renderAddressSelector(parameters) {
	var templateSettings = {
    	interpolate: /{{([\s\S]+?)}}/g
    };

    var templates = [];
    templates['selector'] = _.template($('#template-address-selector').html(), templateSettings);
    templates['option'] = _.template($('#template-address-selector-option').html(), templateSettings);

	$.ajax({
		method: 'POST',
		url: Urls.getAddressList,
		contentType: 'application/json',
		data: JSON.stringify({ storeQuery: StoreQueryFilters.ShipToStoreEnabled }),
		dataType: 'json',
		success: function(data) {
			var html = [];
			var hasAddressBookAddresses = false;
			var selectedAddressID = null;

			dataBuffer[parameters.id] = data.addresses;

			var isAddressSelectedInData = false;
			for (var index = 0; index < data.addresses.length; index++) {
				var address = data.addresses[index];
				
				if (address.isSelected) {
					isAddressSelectedInData = true;
					selectedAddressID = address.ID;
					break;
				}
			}
			
			html['options'] = '';
			for (var index = 0; index < data.addresses.length; index++) {
				var address = data.addresses[index];

				if (address.isShippingAddress) {
					var addressId = address.key ? address.key : address.ID;
					var isSelected = false;

					if (!$shippingAddressForm.find('input[name$="_address1"]').val() && $('[has-warehouse-shipment]').attr('has-warehouse-shipment') == 'true') {
						if (!isAddressSelectedInData) {
							if (!selectedAddressID && parameters.currentAddresses && parameters.currentAddresses.length > 0 && parameters.currentAddresses.indexOf(address.UUID) >= 0) {
								isSelected = true;
								selectedAddressID = address.ID;
							} else if (!selectedAddressID && parameters.selected && address.ID == parameters.selected && parameters.selected != "new") {
								isSelected = true;
								selectedAddressID = address.ID;
							} else if (!selectedAddressID && address.ID == $('#dwfrm_multipleshipping_addressList:visible option').val() && parameters.selected != "new") {
								isSelected = true;
								selectedAddressID = address.ID;
							} else if (!selectedAddressID && address.isDefault && parameters.selected != "new") {
								isSelected = true;
								selectedAddressID = address.ID;
							}
						}
					}

					var optionData = _.extend(address, {
						id: address.UUID,
						cssClass: '',
						selected: isSelected || address.isSelected ? 'selected' : '',
						text: '(' + (!address.displayValue ? addressId : address.displayValue) + ') ' + address.labelText
					});

					if (!address.isMyStore) {
						hasAddressBookAddresses = true;
					}

					html['options'] += templates['option'](optionData);
				}
			}

			if (hasAddressBookAddresses) {
				html['selector'] = templates['selector']({
					id: parameters.id,
					options: html['options']
				});

				var $html = $(html['selector']);

				if (isSelected || address.isSelected) {
					$html.find('option.placeholder').remove();
				}

				$(parameters.el).html($html);
				$(parameters.container).show();
			} else {
				$(parameters.container).hide();
			}

			if (parameters && parameters.callback) {
				parameters.callback({
					selectedAddressID: selectedAddressID,
					isSelected: isSelected,
					optionData: optionData
				});
			}
		}
	});	
}

function editBillingAddress() {
	$('.bill-address-fields').removeClass('collapsed').show();
	$('.billing-select-address').hide();
	
	$('.billing-address-preview').hide();
	$('.billing-address-data.form-info').hide();
	
	$billingAddressFormContainer.show();
	$billingAddressForm.show();
	
	$shippingAddressFormContainer.data('hidden-editable', $('.shipping-address-data.form-info').html().length ? true : false).hide();
	
	$('.form-checkout.shipping-address-section').removeClass('active').find('.shipping-address-cont').addClass('hidden');
	$('.form-checkout.payment-section').removeClass('active').find('.shipping-payment-cont').addClass('hidden');
}

function editShippingAddress() {
	writeShippingAddressFormToBuffer();
	openShippingAddressForm();
}

function openShippingAddressForm() {
	$('.form-checkout.shipping-address-section').attr('panel-mode', 'edit');
	$shippingAddressFormContainer.data('hidden-editable', true).hide();
	$('.shipping-address-data').hide();
	$shippingAddressFormContainer.show();
	$shippingAddressForm.removeClass('add edit').addClass('edit');
	$shippingAddressForm.find('input[name="action"]').val('edit');
		
	$billingAddressForm.hide();
	$('.billing-address-data.form-info').css('display', 'block');
	$('.form-checkout.payment-section').removeClass('active').find('.shipping-payment-cont').addClass('hidden');
	
	$('.shipping-select-address').hide();
	$('.editaddress-shipping').removeClass('collapsed');
}

function setShipToStore(isStoreAddress) {
	$sectionCheckout.attr('is-my-store', isStoreAddress);
	$('#dwfrm_shippingaddress_isStore').prop('checked', isStoreAddress);
}

function isShipToStoreEnabled() {
	return $('#dwfrm_shippingaddress_isStore').prop('checked');
}

function buildShipToStoreDetails($shippingMethods) {
	$shippingMethods.each(function(index, element) {
		var $shippingMethod = $(element);
		var $selectedStore = $shippingMethod.find('.store-selector option:checked');
		var storeSelectorCount = $shippingMethod.find('.store-selector option').length;
		var storeData = $selectedStore.data('address');
		if (storeData) {
			var storeHtml = '';
			if (storeData.name) {
				storeHtml += '<p>' + storeData.name + '</p>';
			}
			if (storeData.address1) {
				storeHtml += '<p>' + storeData.address1 + '</p>';
			}
			if (storeData.address2) {
				storeHtml += '<p>' + storeData.address2 + '</p>';
			}
			if (storeData.city || storeData.state || storeData.postalCode) {
				storeHtml += '<p>' + storeData.city + ', ' + storeData.state + ' ' + storeData.postalCode + '</p>';
			}

			if (storeSelectorCount > 1 && !isStoreShippingAddressOnly) {
				storeHtml += '<a class="action change" tabindex="0">Change Store</a>';
			}

			$shippingMethod.find('.store-details').html(storeHtml);
		}
	});
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shipmentID, shippingMethodID, isShipToStore, $selectedShippingMethod) {
    var shippingAddressType = getShippingAddressType();
	if (shippingAddressType == SiteConstants.AddressTypes.Customer) {
		dataBuffer[CheckoutConstants.User.SelectedCustomerShippingMethod] = shippingMethodID;
	} else if (shippingAddressType == SiteConstants.AddressTypes.Store) {
		dataBuffer[CheckoutConstants.User.SelectedStoreShippingMethod] = shippingMethodID;
	}

	if (isShipToStore || isStoreShippingAddressOnly) {
		setShipToStore(true); 
	} else {
		setShipToStore(false);
	}

    // attempt to set shipping method
    var url = getShippingMethodURL($shippingAddressForm, Urls.selectShippingMethodsList, {shipmentID: shipmentID, shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();

            $('[name*="_shippingMethodID"]').prop('disabled', false);
            updateShippingMethodList($shippingAddressForm, true, null, true, $selectedShippingMethod);
        }
    });
}

/**
 * @description Make the AJAX request to set address data
 * @param {Element} form The form element that present address object
 * @param {Element} Action name to apply to form
 * @returns {Promise}
 */
var setOPCAddress = function (form, name, skipUseBillingAsShipping) {
	var $form = $(form);
	var url = (form == '#billingAddressForm') ? Urls.setOpcAddress : $form.attr('action');
	var sanitizedFormData = {};
	var serializedFormDataArray = $form.serializeArray();
	var hasCountryField = false;
	for (var serializedFormDataKey in serializedFormDataArray) {
		var serializedFormElement = serializedFormDataArray[serializedFormDataKey];
		if (skipUseBillingAsShipping && serializedFormElement.name == 'dwfrm_billingaddress_useAsShippingAddress') {
			sanitizedFormData[serializedFormElement.name] = false;
		} else if (skipUseBillingAsShipping && serializedFormElement.name == 'isShippingAddressSameAsBillingAddress') {
			sanitizedFormData[serializedFormElement.name] = 'off';
		} else if (serializedFormElement && serializedFormElement.name && sanitizedFormData[serializedFormElement.name]) {
			sanitizedFormData[serializedFormElement.name] += ',' + serializedFormElement.value;
		} else {
			sanitizedFormData[serializedFormElement.name] = serializedFormElement.value;
		}
		if (serializedFormElement && serializedFormElement.name && serializedFormElement.name.indexOf('_country') < 0) {
			hasCountryField = true;
		}
	}
	if (hasCountryField) {
		var $countryField = $form.find('[name$="_country"]');
		sanitizedFormData[$countryField.attr('name')] = $countryField.val();
	}
	sanitizedFormData[name] = name;

    return new Promise(function (resolve, reject) {
		$.ajax({
			type: 'POST',
			url: util.ajaxUrl(url),
			data: sanitizedFormData,
			success: function(data) {
				resolve(data);
			},
			error: function(data) {
				reject(data);
			}
		});
    });
};

function pushDataLayerForShippingMethods($shippingMethodList, $selectedShippingMethod) {
	var $selectedShippingMethods;
	if ($selectedShippingMethod) {
		$selectedShippingMethods = $selectedShippingMethod;
	} else {
		$selectedShippingMethods = $shippingMethodList.find('input[type="radio"]:checked');
	}
	$selectedShippingMethods.each(function(index, element) {
		var $this = $(this);
		var $shippingMethod = $this.closest('[shipping-method]');
		var dataObject = {
			value: parseFloat($shippingMethod.attr('amount')),
			shipping_tier: $shippingMethod.attr('shipping-method')
		}

		GoogleTagManagerClient.PushDataLayerForDataLayerType('AddShippingInfo', dataObject, { ContainerSelector: '.order-item[shipment="' + $shippingMethod.closest('form').attr('shipment') + '"]' }).catch(function() {});
	});
}

function handleShippingRestrictions(data) {
	$('.shipping-address-cont').find('> .error').remove();
	var hasShippingRestrictions = data.status == 'shippingRestrictionsError';
	if (hasShippingRestrictions) {
		openRestrictionsPopup(data);
	}

	return hasShippingRestrictions;
}

function openRestrictionsPopup(data) {
	var payload = JSON.parse(data.payload);
	var popup = require('../../popup');
	
	var restrictionList = '';
	if (payload.list && payload.list.length > 0) {
		var list = $.map(payload.list, function (el) {
			var restrictionName = el.name ? el.name + ':<br/>' : '';
			
			return '<li>' + restrictionName + el.message + '</li>';
		}).join('');
		
		restrictionList = '<ul class="shipping-restrictions-popup__list">' + list + '</ul>';
	}
	
	popup.init({
		title: payload.title,
		content: payload.message + restrictionList
	}).showPopup();
}

function renderOptions(optionParent, optionsStoreId) {
	var optionsHtml;
	var optionsStoreOptions = $(optionsStoreId + ' option:selected').data('options');
	var statesList;
	
	if (optionsStoreOptions) {
		statesList = JSON.parse(optionsStoreOptions.replace(/\'/g, '\"'));
		
		if (statesList.length > 1) {
			optionsHtml += '<option value="">' + Resources.SelectPlaceholder + '</option>';
		}
		
		statesList.forEach(function (state) {
			optionsHtml += '<option class="select-option" label="' + state.label + '" value="' + state.code + '">' + state.label + '</option>';
		});

		var $optionParent = $(optionParent);
		$optionParent.empty().append(optionsHtml);

		if (statesList.length <= 1) {
			$optionParent.prop('selectedIndex', statesList.length - 1);
			$optionParent.removeClass('required');
			$optionParent.closest('.formfield').hide();
		} else {
			$optionParent.addClass('required');
			$optionParent.closest('.formfield').show();
		}
	}
}

$(document).on('update-shipping', function() {
	if ($('.shipping-methods-section').length == 0) { return; }
	updateShippingMethodList($shippingAddressForm);
});

exports.init = function (optionsParameter) {
	options = optionsParameter || {};

	if (options && options.Lob && options.Lob.AddressVerification.Enabled) {
		AddressVerificationDialog = require('../../Lob/AddressVerification/AddressVerificationDialog');
	}

	if (options && options.Lob && options.Lob.AddressAutocomplete.Enabled) {
		AddressAutocompleteDialog = require('../../Lob/AddressAutocomplete/AddressAutocompleteDialog');
	}

	isStoreShippingAddressOnly = !!(options && options.AgentStore && options.AgentStore.StoreShippingAddressOnly);
	if (isStoreShippingAddressOnly) {
		setShipToStore(true);
	}
	initializeEvents();
	initializeUserInterface();
};

exports.updateSummary = updateSummary;